import { Deserializer } from "jsonapi-serializer";
import App from "./app.js";
/* eslint no-param-reassign: 0 */
/* eslint prefer-promise-reject-errors: 0 */

class RequestContext {
  constructor(axios) {
    this.axios = axios;
  }

  requestInterceptor() {
    this.axios.interceptors.request.use(
      (config) => {
        // Añadir Authorization solo si el idToken existe y no es vacío
        const idToken = App.redux.store.getState().login.idToken;
        if (idToken) {
          config.headers.Authorization = "Bearer " + idToken;
        } else {
          delete config.headers.Authorization;
        }
        config.headers["Access-Control-Allow-Origin"] = "*";
        config.headers["Access-Control-Allow-Methods"] =
          "DELETE, POST, PUT, GET, OPTIONS";
        config.headers["Access-Control-Allow-Headers"] =
          "Content-Type, Access-Control-Allow-Headers, Authorization, X-Requested-With";
        return config;
      },
      (error) => {
        return Promise.reject(error);
      }
    );
  }

  responseInterceptor() {
    this.axios.interceptors.response.use(
      (response) => {
        if (response.data) {
          if (response.data.success !== undefined && response.data.data) {
            return response;
          }

          if (Array.isArray(response.data)) {
            return response;
          }

          if (response.data.dataQualified !== undefined || response.data.urlPresigned !== undefined) {
            return response;
          }

          if (response.data.investors !== undefined && response.data.documents !== undefined) {
            return response;
          }

          const dataDeserialized = new Deserializer({
            keyForAttribute: "snake_case",
            action: {
              valueForRelationship: (relationship) => ({
                id: relationship.id,
              }),
            },
          }).deserialize(response.data);

          return { data: dataDeserialized };
        }
        return response;
      },
      (error) => {
        if (error.response) {
          if (error.response) {
            return Promise.reject({
              ...error.response.data,
              statusCode: error.response.status,
            });
          } else {
            return Promise.reject({
              ...error,
              statusCode: error.response,
            });
          }
        } else {
          return Promise.reject({
            ...error,
            statusCode: 401,
          });
        }
      }
    );
  }
}

export default RequestContext;
